<template>
  <v-app>
    <v-main>

      <!-- Global Header - Mobile all Pages -->
      <div class = 'global-header-mobile'>
        <div>
          <a href = 'https://healthcasa.com' target = '_blank'><img :src = 'topLeftLogo' alt = 'Health Casa' /></a>
        </div>
        <div>
          <v-icon icon="mdi-menu" @click="menuIsOpen=!menuIsOpen"/>
        </div>
      </div>

      <!-- Mobile Menu overlay from global menu -->
      <v-overlay
          v-model="menuIsOpen"
          class="global-overlay-menu-overlay"
          contained
        >



        <div class = 'global-overlay-menu-header-mobile'>
          <div>
            <a href = 'https://healthcasa.com' target = '_blank'><img :src = 'topLeftLogo' alt = 'Health Casa' /></a>
          </div>
          <div>
            <v-icon icon="mdi-close" @click="menuIsOpen=!menuIsOpen"/>
          </div>
        </div>
        <div class = 'global-overlay-menu-options-mobile'>

          <div><a href = 'https://www.healthcasa.com/' target = '_new'>Home</a></div>

          <div><a href = 'https://www.healthcasa.com/pricing' target = '_new'>Pricing</a></div>

          <div><a href = 'https://www.healthcasa.com/services' target = '_new'>Services</a></div>

        </div>
      </v-overlay>


      <!-- Global Header - Desktop all Pages -->
      <v-app-bar :elevation="0" flat class = 'global-header-desktop'>
          
        <a href = 'https://healthcasa.com' target = '_blank'><img :src = 'topLeftLogo' alt = 'Health Casa' /></a>

        <v-spacer></v-spacer>

        <v-btn text href = 'https://www.healthcasa.com/' target = '_new'>Home</v-btn>

        <v-btn text href = 'https://www.healthcasa.com/pricing' target = '_new'>Pricing</v-btn>

        <v-btn text href = 'https://www.healthcasa.com/services' target = '_new'>Services</v-btn>


      </v-app-bar>
      <div class = 'global-header-below-desktop' :style = "{ backgroundImage: 'url(' + topBackground + ')'}">
      </div>
      <div class = 'global-header-below-mobile' :style = "{ backgroundImage: 'url(' + topBackgroundMobile + ')'}">
      </div>      


      <div class = 'main-content-wrapper'>
        <router-view></router-view>
      </div>
      
    </v-main>
  </v-app>
</template>

<script>
import settings from '@/settings.js';
import topLeftLogo from '@/assets/top-left-logo.png';
import topBackground from '@/assets/top-background.png';
import topBackgroundMobile from '@/assets/top-background-mobile.png';

export default {
  name: 'App',
  data() {
    return {
      topLeftLogo,
      topBackground,
      topBackgroundMobile,
      menuIsOpen: false
    }
  },
  computed: {
    showStage() {
      return settings.stage !== 'prod';
    },
    stage() {
      return settings.stage.toUpperCase();
    }
  }
}
</script>
<style lang="scss">

$primaryDark: #32598C;
$accent: #F25631;
$error: #FF4B55;
$button: #00B0DA;
/* is a bit darker than $button */
$buttonHover: #0096b9;


/* Global Styles */


/* Inter Var font */
:root { font-family: 'Inter', sans-serif; }
@supports (font-variation-settings: normal) {
  :root { font-family: 'Inter var', sans-serif; }
}

/* Background */
body {
  background-color: #fff;
}

/* Global Header - Mobile */

DIV.global-header-mobile {
  display:none;
  justify-content: space-between;
  padding:20px;
  color: white;

  DIV:first-child {
    img {
      width: 125px;
      height:30px;
    
    }
  }

  .v-icon {
    font-size: 24px;
    color: $primaryDark;
  }

  @media (max-width: 1250px) {
    display:flex !important;
  }

}

.v-overlay.global-overlay-menu-overlay {
  background-color: #FFF;
  .v-overlay__scrim {
    background-color: #FFF;
  }

  .v-overlay__content {
    width:100%;
  }

  DIV.global-overlay-menu-header-mobile {
    width:100%;
    display: flex;
    justify-content: space-between;
    padding:20px;
    color: white;

    DIV:first-child {
      img {
        width: 125px;
        height:30px;
      
      }
    }

    .v-icon {
      font-size: 24px;
      color: $primaryDark;
    }
  }

  DIV.global-overlay-menu-options-mobile {
    display: flex;
    flex-direction: column;
    padding-left:20px;
    padding-top:20px;

    DIV {
      padding-bottom:35px;
      a {
        color: $primaryDark;
        text-decoration: none;
        font-weight:500;
        font-size:20px;
      }
    }
  }

}

/* Global Header - Desktop */
.v-app-bar.global-header-desktop {
  background-color: #FFF;
  color: $primaryDark;
  padding-top: 30px;  
  padding-bottom: 30px;  
  padding-left: 60px;  
  box-shadow: none;
  border-bottom: 1px solid #E0E0E0;
  
  img {
    width: 321px;
    height:68px;
  }

  .v-btn {
    color: $primaryDark;
    font-weight:500;
    font-size:20px;
    margin-left:10px;
    text-transform: none;

/*
    &:last-child {
      background-color: $primaryDark;
      color: white;
      font-weight:700;
      border-radius: 9px;
      padding-left:40px;
      padding-right:40px;
      margin-right:60px;
    }
      */
  }

  @media (max-width: 1250px) {
    display:none !important;
  }  

}

DIV.global-header-below-desktop {
  background-size: cover;
  background-position: center;
  height: 161px;
  @media (max-width: 1250px) {
    display:none !important;
  }  
}

DIV.global-header-below-mobile {
  display:none;
  background-size: cover;
  background-position: center;
  height: 157px;
  @media (max-width: 1250px) {
    display:block !important;
  }  
}

.v-main {
  @media screen and (max-width: 1250px) {
    padding-top: 0px !important;
  }
}

.main-content-wrapper {
  max-width:630px;
  padding-left: 20px;
  padding-right: 20px;
  padding-top:20px;
  margin-left:auto;
  margin-right:auto;
}

/* Global Font Configs */

H1 {
  font-size: 32px;
  font-weight: 700;
  color: $primaryDark;
}

H2 {
  font-size: 16px;
  font-weight: 500;
  color: $primaryDark;
}

.section-descriptor {
  margin-top:20px;
  display: flex;

  > DIV .v-icon {
    margin-right: 15px;
    color: $accent;
  }

}

.button-wrapper {
  padding-top:20px;
  padding-bottom:20px;
  display: flex;
  justify-content: space-between;
  margin-top:auto;

  &.center {
    justify-content: center;
  }

  &.dontfixtobottom {
    margin-top:0;
  }  

  BUTTON {
    background-color: $button;
    border-radius: 9px;
    color:#FFF;
    text-transform: none;
    font-weight:700;
    font-size:15px;    
    padding-left:50px;
    padding-right:50px;

    &.v-btn--variant-outlined {
      background-color: transparent;
      border: 1px solid $button;
      color: $button;
    }

    &:hover {
      background-color: $buttonHover;
      color:#FFF;
    }

    &.small {
      padding-left:20px;
      padding-right:20px;      
      @media screen and (max-width: 1250px) {
        padding-left:10px;
        padding-right:10px;
        font-size:13px;
      }
    }
  }


}




</style>